import moment from 'moment-timezone'
import { Trans } from 'react-i18next'

export const pledgeState = (pledge, translationKey) =>
  pledge.state === 'pending' ? (
    <Trans
      i18nKey={`${translationKey}.expireTime`}
      values={{
        time: pledge.business_days_until_expiration,
      }}
    />
  ) : (
    <Trans i18nKey={`organizer.sponsorPledge.status.${pledge.state}`} />
  )

export const canCancelPledge = pledge =>
  ['pending', 'accepted'].includes(pledge.state) &&
  pledge.payment_status !== 'paid'

export const canUpdatePaymentMethod = pledge =>
  pledge.state === 'accepted' &&
  pledge.payment_status === 'failed' &&
  !!pledge.stripe_payment_method_id

// Pledges created before the VPF/MPF split have no allocation; treat them as all VPF.
export const pledgeAllocation = pledge => {
  const total = Number(pledge?.amount) || 0
  const hasSplit = pledge?.vpf_amount != null || pledge?.mpf_amount != null
  if (!hasSplit) {
    return { total, matchAmount: 0, volunteerAmount: total }
  }
  const matchAmount = Number(pledge.mpf_amount) || 0
  const volunteerAmount =
    pledge.vpf_amount != null
      ? Number(pledge.vpf_amount) || 0
      : Math.max(0, total - matchAmount)
  return { total, matchAmount, volunteerAmount }
}

const paymentStatusConfig = {
  unpaid: { color: 'secondary', key: 'unpaid' },
  pending: { color: 'warning', key: 'pending' },
  processing: { color: 'info', key: 'processing' },
  paid: { color: 'success', key: 'paid' },
  failed: { color: 'danger', key: 'failed' },
}

export const pledgePaymentStatus = (pledge, t) => {
  // Only show payment status for accepted pledges
  if (pledge.state !== 'accepted') {
    return null
  }

  const status = pledge.payment_status || 'unpaid'
  const config = paymentStatusConfig[status] || paymentStatusConfig.unpaid

  return (
    <span className={`badge bg-${config.color}`}>
      {t(`organizer.sponsorPledge.paymentStatus.${config.key}`)}
    </span>
  )
}

export default {
  pledgeState,
  pledgePaymentStatus,
  pledgeAllocation,
  canCancelPledge,
  canUpdatePaymentMethod,
}
